<!-- Input color picker (text preview) -->
@if (displayInput) {
  <div class="form-group">
    @if (displayLabel) {
      <label for="signalColor" translate>Signal color</label>
    }
    <div class="input-group">
      <div class="input-group-prepend signal-color-preview">
        <span (click)="toggleColorPicker()" [style.background]="signalColorInput" class="input-group-text" id="basic-addon1">
          <span class="fa-solid fa-droplet"></span>
        </span>
        <input (colorPickerSelect)="onCloseColorPicker($event)"
          [(colorPicker)]="signalColorInput"
          [(cpToggle)]="colorToggle"
          [cpCancelButtonClass]="'btn btn-outline-primary'"
          [cpCancelButton]="true"
          [cpOKButtonClass]="'btn btn-primary'"
          [cpOKButton]="true"
          [cpOutputFormat]="'hex'"
          [cpAlphaChannel]="'disabled'"
          [value]="signalColorInput"
          [ngClass]="inputClass"
          [disabled]="disabled"
          id="signalColor"/>
        </div>
      </div>
    </div>
  }
  <!-- Circular color picker (no text preview) -->
  @if (!displayInput) {
    <div (click)="toggleColorPicker()" class="color-circle-picker-wrapper">
      <span [style.background]="signalColorInput" class="color-circle color-circle-picker">
        <span class="fa-solid fa-droplet"></span>
      </span>
      <input (colorPickerSelect)="onCloseColorPicker($event)"
        [(colorPicker)]="signalColorInput"
        [(cpToggle)]="colorToggle"
        [cpCancelButtonClass]="'btn btn-outline-primary'"
        [cpCancelButton]="true"
        [cpOKButtonClass]="'btn btn-primary'"
        [cpOKButton]="true"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'disabled'"
        [value]="signalColorInput"
        [ngClass]="inputClass"
        [disabled]="disabled"
        id="signalColorNotDisplayInput"/>
      </div>
    }
